import { Box, Card, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { nanoid } from 'nanoid';
import Feed from '../../../Feed';
import Image from '../../../../fl-components/Image';
import { getAllFeedsByOrg } from '../../../../service/feed.service';
import { SET_ORG_FEEDS } from '../../../../redux/constants';
import { SkeletonFeed } from '../../../../fl-components/skeleton';
import BannerCumPoster from './BannerCumPost';

export default function TeacherDashboardFeeds() {
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const feedList = useSelector((state) => state.feeds.orgFeeds);
  const feedOffset = useSelector((state) => state.feeds.orgFeedOffset);
  const feedHasMore = useSelector((state) => state.feeds.orgFeedHasMore);
  const dispatch = useDispatch();
  const [isDataFetching, setIsDataFetching] = useState(false);

  const fetchFeeds = async () => {
    const res = await getAllFeedsByOrg(selectedOrg?.id ?? selectedOrg?.orgId, feedOffset);
    if (res) {
      dispatch({
        type: SET_ORG_FEEDS,
        payload: {
          feeds: res.results,
          offset: feedOffset + 1
        }
      });
    }
    setIsDataFetching(false);
  };

  useEffect(() => {
    if (feedList === null) fetchFeeds();
  }, []);

  return (
    <Box>
      <Grid
        container
        spacing={{
          sm: 1,
          xs: 3
        }}
      >
        <Grid
          item
          md={8}
          xs={12}
          pr={{
            sm: 3
          }}
          mb={{
            sm: 3
          }}
          sx={{
            overflowY: 'scroll',
            height: '100vh',
            '&::-webkit-scrollbar': {
              display: 'none',
              width: '0px'
            },
            '&::-webkit-scrollbar-track': {
              width: '0px'
            }
          }}
          id="feed-container"
        >
          <Box>
            <BannerCumPoster />
            <Box
              pt={3}
              sx={{
                '.MuiCard-root:last-child ': {
                  mb: 3
                }
              }}
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  if (feedHasMore && !isDataFetching) {
                    fetchFeeds();
                    setIsDataFetching(true);
                  }
                }}
                hasMore={feedHasMore}
                getScrollParent={() => document.getElementById('feed-container')}
                loader={
                  <Box my={4}>
                    <SkeletonFeed />
                  </Box>
                }
                useWindow={false}
              >
                <Feed feedDetails={feedList} editable={false} key={nanoid()} />
              </InfiniteScroll>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          sx={{ position: 'sticky !important', alignSelf: 'flex-start !important', top: 0 }}
        >
          {[
            'https://assets-global.website-files.com/5e1f6851f3f22a131226c9f1/60255e7341de62c988dd08aa_DigitalAdvertising.jpg',
            'https://ksac.kiit.ac.in/wp-content/uploads/2021/02/10-Ways-To-Cope-Up-With-Online-Classes-scaled.jpg'
          ].map((img, index) => (
            <Card key={index} sx={{ mb: 3 }}>
              <Image
                src={img}
                sx={{
                  height: { sm: 250, xl: 300 },
                  span: {
                    display: 'flex !important',
                    alignItems: 'center !important'
                  }
                }}
                imageStyle={{ width: '100% !important', height: 'auto !important' }}
              />
            </Card>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
}
